/**
 * @typedef {import('@/types/promotionTypes.js').SegmentDetails} SegmentDetails
 */

import {SelectableList} from '@/components/molecules'
import {useSegmentModalList} from '@/hooks/promotion/segments/useSegmentModalList'
import {SegmentTags} from './SegmentTags'

/**
 * @typedef {Object} SegmentModalListProps
 * @property {SegmentDetails[]} selectedSegments - Currently selected segments state
 * @property {(segments: SegmentDetails[]) => void} setSelectedSegments - Setter for selected segments
 */

/**
 * List component for displaying and selecting segments
 * @param {SegmentModalListProps} props
 */
export const SegmentModalListContent = ({selectedSegments, setSelectedSegments}) => {
  const {setCurrentPage, handleSearch, items, isFetching, currentPage, totalPages, handleSegmentCheckboxChange} =
    useSegmentModalList(selectedSegments, setSelectedSegments)

  console.log(selectedSegments)

  return (
    <div className="flex flex-col">
      <SegmentTags
        segments={selectedSegments}
        handleTagRemove={seg => handleSegmentCheckboxChange({id: seg.segmentId}, false)}
      />
      <SelectableList
        key={`segments-page-${currentPage}`}
        title=""
        items={items}
        onCheckboxChange={handleSegmentCheckboxChange}
        showSearch={true}
        searchPlaceholder="Search segments..."
        selectable={false} // Segments are checkbox-only, not clickable rows
        showSelectedCount={true}
        selectedCount={selectedSegments.length}
        separateItems={true}
        className="flex-1 px-0"
        useExternalSearch={true}
        onSearchChange={handleSearch}
        isLoading={isFetching}
        showPagination={true}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  )
}
